$( document ).on( 'focus', '.search__input', function(){ 
      $(this).closest('form').attr('action','/pages/search-magic');
      $(this).attr('name','query').addClass('ysw-search-instant-search-input');
     
    
});
/*$( document ).on( 'focus', '#search-magic', function(){ 
      $(this).closest('form').attr('action','/pages/search-magic');
      $(this).attr('name','query').addClass('ysw-search-instant-search-input');
      console.log('header__icon--search');
     
    
});
$('#search-magic').click(function() {	
	 $(this).closest('form').attr('action','/pages/search-magic');
      $(this).attr('name','query').addClass('ysw-search-instant-search-input');
      console.log('header__icon--search1');
})*/

 
$( document ).on( 'focus', '.mobile-nav__search-form input', function(){ 
    $(this).closest('form').attr('action','/pages/search-magic');
    $(this).attr('name','query').addClass('ysw-search-instant-search-input');
    
}); 